// Mutations
export const SET_GRAFICOS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.corretora.data = payload
    state.corretora.lastUpdate = new Date()
  }
}
export const ADD_GRAFICOS = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.corretora.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.corretora.data.push(data)
      }
    })
  }
}
export const SET_GRAFICOS_LOADING = (state, payload) => {
  state.corretora.loading = payload
}
